export { default as ReactDualRangeSlider } from "./components/react-dual-range-slider";



// WEBPACK FOOTER //
// ./src/index.js